import { GlowTextBody } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type SocialProofProps = {
    socialProof?: string;
};

export const SocialProof: Component<SocialProofProps> = ({ socialProof }) => {
    if (!socialProof) {
        return null;
    }
    return (
        <span
            className={
                'absolute bottom-3 left-0 bg-background-neutral rounded-r-0.5 flex p-0.5 animate-socialProofAnimation'
            }
        >
            <GlowTextBody text={socialProof} TagName={'span'} className={'text-left'} />
        </span>
    );
};
